<template>
  <div class="tag">
    <p v-if="titleIsHidden">Access</p>

    <div class="tag--input">
      <span 
        v-for="tag in value" 
        v-bind:key="tag.index"
        class="tag--input--tag"
      >
        <span class="tag--input--tag--title">{{ tag.name }}</span>

        <button 
          type="button" 
          class="tag--input--remove" 
          @click="removeTag(tag)"
        >
          &times;
        </button>
      </span>

      <input
        class="tag--input--text" 
        :placeholder="inputPlaceholder"
        @keydown.enter.prevent="addTag"
        @focus="showList"
        v-model="query"
      >
    </div>

    <ul class="tag--list">
      <li
        v-for="(item, index) in computedList"
        v-bind:key="index"
        v-bind:data-index="index"
        v-on:click="addTag(item.name, item.id)"
      >
        {{ item.name }}
      </li>

      <li v-if="computedList.length === 0">No results found 😟</li>
    </ul>
  </div>
</template>

<script>
  import { API } from '../../services/api.ts';
  import Search from './search.vue'

  export default {
    name: 'Tag',
    props: [
      'value',
      'titleIsHidden',
      'list',
      'inputPlaceholder'
    ],
    components: {
      Search
    },
    data() {
      return {
        newTag: '',
        query: ''
      }
    },
    methods: {      
      addTag(name, id) {
        // state
        for (let index = 0; index < this.value.length; index++) {
          const element = this.value[index];
          
          if (element.name === name) {
            return
          }
        }

        this.value.push(
          {
            name: name,
            id: id
          }
        );
        
        // api
        let currentIds = [];

        for (const item of this.value) {
          currentIds.push(item.id);
        }

        this.$emit('addTag', currentIds, this.value);
      },
      removeTag(tag) {
        this.$emit('input', this.value.filter(t => t !== tag))
        this.$emit('removeTag', tag.id, this.value);
      },
      showList() {
        let allTagList = document.querySelectorAll('.tag--list');
        let tagList = this.$el.querySelector('.tag--list');

        for (let i = 0; i < allTagList.length; i++) {
          allTagList[i].style.display = 'none';
        }

        tagList.style.display = 'block';
      }
    },
    computed: {
      computedList: function () {
        var self = this

        return this.list.filter(function (item) {
          return item.name.toLowerCase().indexOf(self.query.toLowerCase()) !== -1
        })
      }
    }
  }
</script>

<style lang="scss">
  .tag {
    position: relative;

    p {
      font-weight: bold;
      padding-bottom: 15px;
    }

    &--input {
      display: flex;
      flex-wrap: wrap;
      overflow: scroll;
      padding-left: 2px;
      border: 1px solid var(--blue-medium);
      background-color: white;

      &--tag {
        display: inline-flex;
        position: relative;
        background-color: var(--blue);
        height: 24px;
        border-radius: 12px;
        padding: 0 5px 0 10px;
        margin-top: 2px;
        margin-right: 3px !important;

        &:last-of-type {
          margin-right: 0;
        }

        .tag--input--tag--title {
          color: white !important;    
          font-size: 12px;
          margin-right: 25px;
          display: inline-block;
          margin-top: 4px;
        }

        button {
          background-color: transparent;
          border: 0;
          color: white;
          cursor: pointer;
          position: absolute;
          height: 25px;
          right: 5px;
        }
      }

      &--remove {
        font-size: 1.125rem;
        line-height: 1;

        &:focus {
          outline: 0;
        }
      }

      &--text {
        outline: 0;
        margin-left: 5px;
        border: 0;
        height: 28px;
        display: inline-flex;
        flex: 1;
      }
    }

    &--list {
      background-color: var(--white);
      border: 1px solid var(--grey-light);
      padding: 4px;
      margin-top: 5px;
      display: none;
      max-height: 150px;
      overflow: scroll;

      li {
        cursor: pointer;
      }
    }

    span {
      margin-bottom: 0 !important;
    }
  }
</style>